import Vue from 'vue';
import VueRouter from 'vue-router';
import GeneralLayout from '@/views/generalLayout';
import HomePage from '@/views/Home/homePage.vue';


// 产品介绍
import Tablet5G from '@/views/productIntroduction/5GTablet.vue';
import VideoRecorder from '@/views/productIntroduction/videoRecorder.vue';
import WisdomTeaching from '@/views/productIntroduction/wisdomTeaching.vue';
// 解决方案
import EducationBenefits from '@/views/theSolution/educationBenefits.vue';
import NewsCenter from '@/views/newsCenter/index.vue';
import EcologicalCooperation from '@/views/ecologicalCooperation/index.vue';
Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: GeneralLayout,
    component: GeneralLayout,
    redirect: '/homePage',
    children: [
      {
        path: '/homePage',
        name: 'homePage',
        component: HomePage,
      },
      // 产品介绍
      {
        path: '/tablet5G',
        name: 'tablet5G',
        component: Tablet5G,
      },
      {
        path: '/videoRecorder',
        name: 'videoRecorder',
        component: VideoRecorder,
      },
      {
        path: '/wisdomTeaching',
        name: 'wisdomTeaching',
        component: WisdomTeaching,
      },
      // 解决方案
      {
        path: '/educationBenefits',
        name: 'educationBenefits',
        component: EducationBenefits,
      },
      {
        path: '/ecologicalCooperation',
        name: 'ecologicalCooperation',
        component: EcologicalCooperation,
      },
      {
        path: '/newsCenter',
        name: 'newsCenter',
        component: NewsCenter,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
